import React, { FC, Fragment } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { dark as darkTheme } from './theme';
import { ThemeProvider as MUIThemeProvider } from '@material-ui/styles';
import { muiThemeDark } from './muiTheme';
import { CssBaseline } from '@material-ui/core';

export const GlobalCss = createGlobalStyle`

  // @keyframes preventBurnIn {
  //   0% {
  //     filter: hue-rotate(0);
  //   }
  //
  //   2%, 100% {
  //     filter: hue-rotate(2deg);
  //   }
  // }
  //
  // body {
  //   animation: 1800s infinite alternate preventBurnIn;
  // }
`;

const DarkThemeProviderWrapper: FC = ({ children }) => (
  <Fragment>
    <ThemeProvider theme={darkTheme}>
      <MUIThemeProvider theme={muiThemeDark}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeProvider>
    <GlobalCss />
  </Fragment>
);

export default DarkThemeProviderWrapper;
